import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionService, HttpService } from '@ecp-caf/caf-common';
import { forkJoin } from 'rxjs';

@Injectable()
export class UserService {

  constructor(
    private http: HttpClient,
    private httpSvc: HttpService,
    private sessionSvc: SessionService,
  ) { }

  getUsersByIds(ids: string[]): Observable<any> {
    var pathUrl = '/api/runtime/sys/v1.0/users';
    return forkJoin(ids.map(id => this.http.get(pathUrl + `/${id}` + `?mode=0002`)));//mode用于获取组织全路径
  }

  getUserList(searchValue: string, index: number, size: number): Observable<any> {
    if (searchValue) {
      return this.getUser('codeorname', searchValue, index, size);
    } else {
      return this.getUser('', '', index, size);
    }
  }

  private getUser(field: string, value: string, index: number, size: number): Observable<any> {
    let url = `/api/runtime/sys/v1.0/users`;
    url += field ? 
      `?param={"notGetCurrentUser":false,"pageIndex":${index},"pageSize":${size},"${field}":'${value}',"orderField":"order", "withAllOrg": "true", "queryMode":"0002"}` :
      `?param={"notGetCurrentUser":false,"pageIndex":${index},"pageSize":${size},"orderField":"order", "withAllOrg": "true", "queryMode":"0002"}`;
    return this.httpSvc.get(url);
  }

  getUserList_Assign(searchValue: string, index: number, size: number, withAllOrg?: boolean, orgId?: string): Observable<any> {
    if (searchValue) {
      return this.getUser_Assign('codeorname', searchValue, index, size, withAllOrg, orgId);
    } else {
      return this.getUser_Assign('', '', index, size, withAllOrg, orgId);
    }
  }

  private getUser_Assign(field: string, value: string, index: number, size: number, withAllOrg: boolean, orgId: string): Observable<any> {
    let url = `/api/runtime/sys/v1.0/users`;
    url += field ? 
      `?param={"notGetCurrentUser":false,"pageIndex":${index},"pageSize":${size},"${field}":'${value}',"orderField":"order", "withAllOrg": "true", "queryMode":"0002"}` :
      `?param={"notGetCurrentUser":false,"pageIndex":${index},"pageSize":${size},"orderField":"order", "withAllOrg":'${withAllOrg}',"orgId":'${orgId}', "queryMode":"0002"}`;
    return this.httpSvc.get(url);
  }

  /**
   * 构造Header
   */
  private getBatchHeader(): any {
    const sessionId = this.sessionSvc.getCurrentSeesionId();
    const headers = new HttpHeaders().set('SessionId', sessionId).set('Accept', 'application/json');
    // 此处key必须是headers
    return headers;
  }

  /**
   * 转换配置大小写
   * @param jsonObj Object
   */
  toUpperCase(jsonObj: object): any {
    if (typeof (jsonObj) === 'object') {
      for (const key of Object.keys(jsonObj)) {
        jsonObj[key.substring(0, 1).toUpperCase() + key.substring(1)] = jsonObj[key];
        delete (jsonObj[key]);
      }
    }
    return jsonObj;
  }
}
